module.exports = __webpack_public_path__ + "img/backnode1.8429f6fc.png";